/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Gr as Gr,
  rec_JSXRuntime as JSXRuntime,
  rec_Qx as Qx,
  rec_React as React,
  rec_Sn as Sn,
  rec_Yx as Yx,
  rec_nS as nS,
} from "../../runtime/index.jsx";
export function Componente_rk_114_107(e) {
  return (
    <li
      key={e.id}
      children={
        <Sn
          to={`/proyectos/${e.id}`}
          className={`flex flex-wrap items-center gap-2 rounded-xl border border-(--border) px-3 py-2 text-sm transition hover:bg-(--accent-bg)`}
          children={[
            <Gr className={`h-4 w-4 shrink-0 text-(--text)`} />,
            <span
              className={`h-2.5 w-2.5 shrink-0 rounded-full`}
              style={{
                background: nS(e.color),
              }}
            />,
            <span
              className={`min-w-0 flex-1 truncate text-(--text-h)`}
              children={e.nombre}
            />,
            e.estado && e.estado !== `ACTIVO` && (
              <span
                className={`rounded-full px-2 py-0.5 text-[10px] ${Qx(e.estado)}`}
                children={Yx(e.estado)}
              />
            ),
            typeof e.abiertas == `number` && (
              <span
                className={`shrink-0 text-[11px] text-(--text)`}
                children={[
                  e.abiertas,
                  ` abiertas · `,
                  e.completadas,
                  `/`,
                  e.totalTareas,
                ]}
              />
            ),
            e.miRol && (
              <span
                className={`shrink-0 text-[11px] text-(--text)`}
                children={Yx(e.miRol)}
              />
            ),
          ]}
        />
      }
    />
  );
}
